import {jwtDecode} from 'jwt-decode';

export const isTokenValid = (token) => {
  if (!token) return false;
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000; // Current time in seconds
    if (decoded.exp < currentTime) {
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      return false;
    }
    return decoded; // Return decoded token if valid
  } catch (error) {
    console.error('Invalid token:', error);
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    return false;
  }
};

export const getUserRoleAndStoreId = () => {
  const role = localStorage.getItem('role');
  let storeId = null;
  if (role === 'store_owner') {
    storeId = localStorage.getItem('selectedStoreId');
    if (!storeId) {
      const stores = JSON.parse(localStorage.getItem('stores') || '[]');
      storeId = stores[0]?.id?.toString() || null;
      if (storeId) {
        localStorage.setItem('selectedStoreId', storeId);
      }
    }
  } else if (role === 'store_manager') {
    storeId = localStorage.getItem('storeId');
  }
  return { role, storeId };
};